function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M1.539,11.348L1.539,13.014C1.539,14.586 1.539,15.371 2.027,15.86C2.515,16.348 3.301,16.348 4.872,16.348L13.206,16.348C14.777,16.348 15.563,16.348 16.051,15.86C16.539,15.371 16.539,14.586 16.539,13.014L16.539,11.348",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(110,110,110)",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.039,1.348L9.039,12.181M9.039,12.181L4.039,7.121M9.039,12.181L14.039,7.121",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(110,110,110)",
      strokeWidth: "1.5px",
      strokeLinejoin: "round"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.5a7d53692c385baccd288aeea7ad7fdf.svg";
export { ForwardRef as ReactComponent };